import { NumericFormat } from 'react-number-format';

const CurrencyInput = ({ displayType = 'text', value = 0, allowNegative = true }) => {
  return (
    <NumericFormat
      displayType={displayType}
      value={String(value)}
      decimalScale={2}
      fixedDecimalScale={2}
      allowNegative={allowNegative}
      thousandSeparator
    />
  );
};

export default CurrencyInput;
